/**
 * Centralized polling/auto-refresh configuration
 *
 * All background refresh intervals are defined here for easy adjustment.
 * Values are in milliseconds.
 */

export const POLLING_INTERVALS = {
  // Modern UI incidents list (homepage)
  INCIDENTS: 30000,        // 30 seconds

  // Expanded incident details (Modern UI)
  INCIDENT_DETAILS: 120000, // 2 minutes

  // Problem detail data (Impact Command Center)
  PROBLEM_DATA: 120000,    // 2 minutes

  // Configuration: Delivery Streams list
  DELIVERY_STREAMS: 120000, // 2 minutes

  // Configuration: Leadership Search
  LEADERSHIP_SEARCH: 120000, // 2 minutes

  // Configuration: Brand Manager
  BRAND_MANAGER: 120000, // 2 minutes

  // User Management: User list
  USER_MANAGEMENT: 120000,  // 2 minutes

  // Profile: Feature toggle definitions
  PROFILE_FEATURES: 120000, // 2 minutes

  // System: Build information
  SYSTEM_STATUS: 300000,    // 5 minutes (static info, refresh less frequently)

  // Impact reports table on the Client-Business Impact tab (viewer page)
  IMPACT_REPORTS: 30000,   // 30 seconds

  // Collaborative editing patch polling
  PATCH_POLLING: 10000,    // 10 seconds

  // Incident reported impacts (detail page)
  INCIDENT_IMPACTS: 30000, // 30 seconds

  // Historical problems list (home page)
  HISTORICAL_INCIDENTS: 120000, // 2 minutes

  // Session keepalive
  SESSION_KEEPALIVE: 300000, // 5 minutes

  // Configuration: Global Feature Toggles (US1945335)
  // 30s matches the backend DynamoDB cache TTL so reads are always fresh
  GLOBAL_TOGGLES_REFRESH: 30000, // 30 seconds

  // PagerDuty activity panel (workflows fired, responders, leadership group)
  // 30s keeps the panel near-real-time during an active incident; the backend
  // caches per-incident so this won't hammer PD on a hot incident.
  PD_ACTIVITY: 30000, // 30 seconds
};

/**
 * Polling behavior configuration
 */
export const POLLING_CONFIG = {
  // Pause polling when browser tab is hidden (saves bandwidth)
  pauseWhenHidden: true,

  // Run refresh immediately when tab becomes visible again
  refreshOnTabFocus: true,

  // Maximum number of consecutive failed refreshes before stopping
  maxConsecutiveFailures: 5,

  // Show error toast after N consecutive failures
  showErrorAfterFailures: 3
};

const pollingConfig = {
  POLLING_INTERVALS,
  POLLING_CONFIG
};

export default pollingConfig;
